// Deprecated. Import from 'metadata.js' directly instead.
export { getCountryCallingCode as default } from './metadata'


// WEBPACK FOOTER //
// ../source/getCountryCallingCode.js